import { lang } from '@umu/ukit-lang';
/**
 * @author librajt
 * @description
 */

import React, { Component } from 'react';
import { components } from 'common';
const { Portal } = components;
import AiReportSection from '../@aiReportSection/aiReportSection';
import { IAiReportData } from '@umu/umu-types/src/interface/aiReportInfo';
import PagePanel from '../@pagePanel/pagePanel';
import AiReportPicShare from './components/@aiReportPicShare/aiReportPicShare';
import './aiReport.scss';

interface IProps {
    userName: string;
    homeworkId: number;
    aiVoiceCheckSwitch?: number;
    aiReportInfo: IAiReportData;
    hideHeader?: boolean;
    expressiveMinScore: number;
    expressiveFullScore: number;
    allow_ytmw_cal_to_score?:number;
    ytmw_def_val?:number;
}

interface IAireportState {
    isShowPanel: boolean;
}

export default class AiReport extends Component<IProps, IAireportState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isShowPanel: false,
        };
    }

    public renderHeader() {
        return (
            <div className="ai-report-header">
                <div className="ai-report-actions">
                    <span className="action-item uppercase" onClick={this.shareAiReport}>
                        {lang('分享')}
                    </span>
                </div>
                <div className="title">{lang('表现力')}</div>
            </div>
        );
    }

    public renderPagePanel() {
        if (!this.state.isShowPanel) {
            return null;
        }
        return (
            <Portal preventBodyScroll={true}>
                <PagePanel
                    clsName="ai-report-share-dialog"
                    leftCallback={this.closeShare}
                    leftClsName="icon-back"
                    leftTitle=""
                    title={lang('AI分析报告')}
                    rightTitle=""
                >
                    <AiReportPicShare homeworkId={this.props.homeworkId} />
                </PagePanel>
            </Portal>
        );
    }

    public render() {
        const { aiVoiceCheckSwitch, userName, aiReportInfo, expressiveMinScore, expressiveFullScore,allow_ytmw_cal_to_score,ytmw_def_val } = this.props;
        return (
            <div className="ai-report">
                {this.props.hideHeader ? null : this.renderHeader()}
                <AiReportSection
                    aiVoiceCheckSwitch={aiVoiceCheckSwitch}
                    userName={userName}
                    aiReportInfo={aiReportInfo}
                    expressiveMinScore={expressiveMinScore}
                    expressiveFullScore={expressiveFullScore}
                    allow_ytmw_cal_to_score={allow_ytmw_cal_to_score}
                    ytmw_def_val={ytmw_def_val}
                />
                {this.renderPagePanel()}
            </div>
        );
    }

    private shareAiReport = () => {
        this.setState({
            isShowPanel: true,
        });
    };

    private closeShare = () => {
        this.setState({
            isShowPanel: false,
        });
    };
}
